import React, { useEffect, useState } from "react";
import news from "./old.module.css";
import Nav from "../../Navbar/Nav";
import { Link } from "react-router";
import { useParams } from "react-router";
import Footer from "../../../Components/Footer/Footer";
import {
  fetchAllPosts,
  imageUrl,
  fetchPostBySlug,
} from "../../../Api/PostManApi";
import SafeHTML from "../../../ComponentDash/SafeHtml/SafeHtml";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import { Helmet } from "react-helmet"; // Import Helmet directly
// Make sure this is the correct path

const News = () => {
  const { id } = useParams();
  const url = window.location.href;
  const iconSize = 30;
  const [loading, setLoading] = useState(true);
  const [post, setPost] = useState(null);
  const [posts, getPosts] = useState([]);

  useEffect(() => {
    const fetchAllPost = async () => {
      const result = await fetchAllPosts();
      const data = Array.isArray(result)
        ? result
        : Array.isArray(result.data)
        ? result.data.post
        : [];
      getPosts(data);
    };
    fetchAllPost();
  }, []);

  useEffect(() => {
    const getPost = async () => {
      try {
        setLoading(true);
        const response = await fetchPostBySlug(id);
        if (response) {
          const data = response?.data || {};
          setPost(data);
        } else {
          setPost(null);
        }
      } catch (error) {
        console.error("Error fetching post:", error);
        setPost(null);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      getPost();
    }
  }, [id]);

  return (
    <>
      {/* SEO Meta Tags in Head */}
      {post && (
        <Helmet>
          <title>{post.title}</title>
          <meta
            name="description"
            content={post.description.substring(0, 160)}
          />
          <link rel="canonical" href={url} />

          {/* Open Graph */}
          <meta property="og:title" content={post.title} />
          <meta
            property="og:description"
            content={post.description.substring(0, 160)}
          />
          <meta property="og:url" content={url} />
          <meta property="og:type" content="article" />
          <meta
            property="og:image"
            content={`${imageUrl}/post_images/${post.images}`}
          />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={post.title} />
          <meta
            name="twitter:description"
            content={post.description.substring(0, 160)}
          />
          <meta
            name="twitter:image"
            content={`${imageUrl}/post_images/${post.images}`}
          />

          {/* Schema.org */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "NewsArticle",
              headline: post.title,
              description: post.description.substring(0, 160),
              datePublished: post.createdAt,
              author: {
                "@type": "Person",
                name: post.author?.name || "Unknown Author",
              },
              image: `${imageUrl}/post_images/${post.images}`,
            })}
          </script>
        </Helmet>
      )}

      {/* Page Content */}
      <Nav />
      <div className={news.news}>
        <div className={news.news}>
          <div className={news.container}>
            <div className={news.content}>
              <div className={news.imgI}>
                <img src={`${imageUrl}/post_images/${post?.images}`} alt="" />
              </div>
              <div className={news.flex}>
                <div className={news.flexI}>
                  <div className={news.blockI}>
                    <h4>Hot News</h4>
                    <h2>{post?.title}</h2>

                    <SafeHTML html={post?.description} />

                    {/* <p>
            Esther Macharia, Head of Hospital Operations, expressed
            gratitude for the participation of over 250 healthcare
            facilities utilising Smart’s solutions. She noted that
            technology is crucial in improving customer service and
            operational efficiency. Macharia showcased innovations
            like MediSmart, adopted by over 5,000 facilities, and
            SmartHealth+, which enhances hospital management through
            workflow automation. These advancements support 18,460
            patient visits daily, reflecting significant
            improvements in healthcare accessibility and outcomes.
          </p> */}
                  </div>
                  {/* <div className={news.blockII}>
          <p>
            <SafeHTML
              html={getFirstNWords(
                post?.description,
                200,
                400
              )}
            />
          </p>
          <p> */}
                  {/* Read also: */}{" "}
                  {/* <span> Kwara government unveils plans to boost yo</span> */}
                  {/* </p>
          <p>
            <SafeHTML
              html={getFirstNWords(post?.description, 200, 50000)}
            />
          </p>
        </div> */}
                  <div className={news.blockIII}>
                    <h3>By {post?.author?.name}</h3>
                    <p>Share Via</p>
                    <div className={news.icons}>
                      <FacebookShareButton title={post?.title} url={url}>
                        <FacebookIcon size={iconSize} round />
                      </FacebookShareButton>
                      <TwitterShareButton title={post?.title} url={url}>
                        <TwitterIcon size={iconSize} round />
                      </TwitterShareButton>
                      {/* <FaTwitter className={news.iconII} /> */}
                      {/* <FaYoutube className={news.iconIII} /> */}
                    </div>
                  </div>
                </div>
                <div className={news.flexII}>
                  <button>More News</button>
                  {posts.slice(0, 6).map((post) => (
                    <div className={news.card} key={post?._id}>
                      <h4>{`${post?.category} News`}</h4>
                      <img
                        src={`${imageUrl}/post_images/${post?.images}`}
                        alt=""
                      />
                      <Link to={`/${post?.slug}`}>
                        <p>{post?.title}</p>
                      </Link>
                    </div>
                  ))}

                  {/* <div className={news.card}>
          <h4>{category}</h4>
          <p>
            Nigerian court frees Binance executive Tigran Gambaryan
            from money laundering charges after eight months
          </p>
        </div>
        <div className={news.card}>
          <h4>Cryptocurrency</h4>
          <p>
            EFCC freezes #548.6 million linked to crypto platforms
            ByBit and KuCoin
          </p>
        </div>
        <div className={news.cardI}>
          <h4>Cryptocurrency</h4>
          <p>
            EFCC freezes #548.6 million linked to crypto platforms
            ByBit and KuCoin
          </p>
        </div> */}
                </div>
              </div>
              <div className={news.ads}>
                <h1>GOOGLE ADSENSE POSTS</h1>
              </div>
              <div className={news.grid}>
                {posts.slice(3, 6).map((post) => (
                  <div className={news.gridI} key={post?._id}>
                    <img
                      src={`${imageUrl}/post_images/${post?.images}`}
                      alt=""
                    />
                    <div className={news.btn}>
                      <h5>News</h5>
                      <h5>Business</h5>
                      <h5>Startup</h5>
                    </div>
                    <Link to={`/${post?.slug}`}>
                      <p>{post?.title}</p>
                    </Link>
                  </div>
                ))}
              </div>
              <div className={news.ads}>
                <h1>ADS POST</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {loading ? (
          <p>loading ...</p>
        ) : (
          <div>
            <Nav />
            {/* ... rest of your component ... */}
          </div>
        )}
        <Footer />
      </div>
    </>
  );
};

export default News;
